import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaFilm,
  FaStar,
  FaRocket,
  FaMobileAlt,
  FaUsers,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const ShortFilmProductionServicesInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Short Film Production Services in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Elevate Your Story</Subheading>}
        heading={
          <Heading>
            Professional{" "}
            <span tw="text-primary-500">Short Film Production</span> in Bur
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we offer expert short film production services in
            **Bur Dubai**, combining creative storytelling with high-quality
            visuals to bring your vision to life. Create impactful films that
            resonate with your audience.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1599240211563-17590b1af857?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Film production
          "https://images.unsplash.com/photo-1578221569814-fd71a9718db5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Camera crew
          "https://images.unsplash.com/photo-1602491453631-e2a5ad90a131?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Editing suite
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Project"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Film Production in Bur Dubai"
        description="We craft short films with creativity and precision."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Cinematic Quality",
            description: "High-definition visuals that captivate.",
          },
          {
            icon: <FaFilm color="#ff5464" size={40} />,
            title: "Compelling Stories",
            description: "Narratives that engage and inspire.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Award-Winning Team",
            description: "Trusted by brands and filmmakers.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Timely delivery without compromise.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Cross-Platform Ready",
            description: "Optimized for all screens.",
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "Collaborative Approach",
            description: "Your vision, our expertise.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Film Production Process"
        description={
          <Description>
            We create short films with a streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your story and goals.</li>
              <li>Scripting: Craft a compelling narrative.</li>
              <li>Pre-Production: Plan every detail meticulously.</li>
              <li>Filming: Capture stunning visuals.</li>
              <li>Post-Production: Edit and polish to perfection.</li>
              <li>Delivery: Provide a film ready for impact.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1533928298208-27ff66555d8d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Film production
          "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Camera crew
          "https://images.unsplash.com/photo-1543536448-1e76fc2795bf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Editing suite
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Cinematic Wins in Bur Dubai"
        description="Our films have made a mark in the industry."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Viral Campaigns",
            description: "Short films that gained massive reach.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Award Recognition",
            description: "Films celebrated at festivals.",
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "95% approval from our clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Tell Your Story?</Subheading>}
        heading="Short Film Production in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for professional short film production
            services in Bur Dubai. Create a film that inspires and
            captivates—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1523207911345-32501502db22?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Camera crew
          "https://images.unsplash.com/photo-1501369762096-edcbbcf4ad81?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Editing suite
          "https://images.unsplash.com/photo-1485846234645-a62644f84728?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Film production
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
